import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export const GuaranteeSection: React.FC = () => {
  return <section className="py-20 px-4 bg-gray-50" data-id="element-100">
      <div className="container mx-auto max-w-5xl" data-id="element-101">
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-12 relative overflow-hidden" data-id="element-102">
          {/* Decorative blur elements */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-103"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-green-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 translate-y-1/2" data-id="element-104"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-105">
            {/* Left: Seal */}
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-106">
              <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-107">
                <div className="absolute inset-0 border-4 border-dashed border-blue-300 rounded-full animate-spin-slow" data-id="element-108"></div>
                <div className="absolute inset-2 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex flex-col items-center justify-center text-white shadow-lg" data-id="element-109">
                  <ShieldCheckIcon className="w-16 h-16 mb-2" data-id="element-110" />
                  <span className="font-bold text-center leading-tight" data-id="element-111">
                    45 DÍAS
                    <br data-id="element-112" />
                    GARANTÍA
                  </span>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="w-full md:w-2/3" data-id="element-113">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-114">
                Garantía de Satisfacción 100%
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-115">
                Estamos tan seguros de que este sistema va a transformar tus
                clases que te ofrecemos una garantía incondicional. Si aplicás
                el sistema y no ves resultados, te devolvemos tu dinero.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-116">
                <li className="flex items-center gap-3" data-id="element-117">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-118" />
                  <span className="text-gray-800 font-medium" data-id="element-119">
                    Ningún riesgo para vos
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-120">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-121" />
                  <span className="text-gray-800 font-medium" data-id="element-122">
                    Reembolso completo del 100%
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-123">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-124" />
                  <span className="text-gray-800 font-medium" data-id="element-125">
                    Sin hacer preguntas
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-126">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-127" />
                  <span className="text-gray-800 font-medium" data-id="element-128">
                    Procedimiento simple vía email
                  </span>
                </li>
              </ul>

              <button onClick={scrollToOffer} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-colors duration-300" data-id="element-129">
                Probar sin riesgos
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};